import React, { CSSProperties, ChangeEvent } from "react";
import * as Sentry from "@sentry/react";

export interface IChoice {
    value: string
    label?: string
    enabled: boolean
};


interface IDropDownMenu {
    menuName: string
    defaultVal?: Partial<IChoice>
    required: boolean
    choices: IChoice[]
    onSelect?: Function
    testId?: string
    height?: string
    disabled?: boolean
};


// Generic search function that is expected to always find at most one item within the given array of options.
export const findOptionFromList = (optionValue: string | number, choices: IChoice[]): IChoice =>
    choices.filter(option => option.value === String(optionValue))[0];


export default function DropDownMenu({ menuName, defaultVal, required, choices, onSelect, testId, height, disabled }: IDropDownMenu) {

    const onSelectOption = (event: ChangeEvent<HTMLSelectElement>) => {
        event.preventDefault();
        onSelect && onSelect(event);
    };

    const dropDownListStyles: CSSProperties = {
        height: height ? height : '5vh',
        border: '1px solid #C4C4C4',
        borderRadius: '10px',
        minWidth: '50%',
        marginTop: '-1px',
        marginLeft: '-1px',
    };

    if (defaultVal && defaultVal.value && !choices.map(item => item.value).includes(defaultVal.value)) {
        Sentry.addBreadcrumb({
            category: 'breadcrumb_change',
            message: `'Default value is not within the choices values'`,
            data: {
                value: defaultVal,
            },
        });
    }

    return (
        <select
            style={dropDownListStyles}
            name={menuName}
            required={required}
            defaultValue={defaultVal != null ? defaultVal.value : undefined}
            onChange={event => onSelectOption(event)}
            data-testid={testId || 'drop-down-menu-testid'}
            disabled={disabled}
        >
            {/* If there's no default value provided, then add an empty option. The ==null returns True also for undefined. */}
            {defaultVal == null && <option />}

            {choices.map((item: IChoice, index: number) => {
                // Ensure 'enabled' property exists and is true if not present or null
                if (item.enabled == null) {
                    item.enabled = true;
                }
                return (
                    <option
                        key={`dropDownList-${index}`}
                        value={item.value}
                        disabled={!item.enabled}
                    >
                        {/* TODO: handle opacity when scrolling up, the disabled dropdown comes up */}
                        {item.label ? item.label : item.value}
                    </option>
                );
            })}

        </select>
    );
};
